import React, { useCallback, useState, useEffect } from 'react';

import {
  Box,
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage
} from '@chakra-ui/react';

const FieldComponent = ({
  dataId = null,
  fieldId,
  submitAttempted,
  defaultPlaceholder,
  fieldLabel,
  fieldValue,
  required,
  errorMessage,
  noFileSelectedMessage = `No file selected.`,
  onChange = (v) => { },
  onReady = () => { }
}) => {
  const [isError, setIsError] = useState(required);
  const [fileSelected, setFileSelected] = useState(null);

  const handleOnChange = useCallback(
    (fileRef) => {
      const fileIsNullOrUndefined =
        typeof fileRef === `undefined` || fileRef === null;

      const isEmpty = required === true && fileIsNullOrUndefined === true;

      const hasExceeded =
        fileIsNullOrUndefined === false && fileRef.size > 5242880; // 5mb

      const isInvalid = isEmpty || hasExceeded;

      setFileSelected(fileIsNullOrUndefined === false ? fileRef.name : null);
      setIsError(isInvalid);

      onChange({
        fieldId,
        value: fileRef,
        label: fieldLabel,
        isValid: isInvalid === false
      });
    },
    [onChange, fieldId, fieldLabel, required]
  );

  useEffect(() => {
    onReady({
      fieldId,
      required
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl
      mb="3"
      isInvalid={submitAttempted && isError}
      isRequired={required}>
      <FormLabel
        id={`field-label-file-${fieldId}-${fieldLabel}`}
        htmlFor={fieldId}
        mb="1.5">
        {fieldLabel}
      </FormLabel>
      <Box pos="relative">
        <Input
          maxWidth="102px"
          type="file"
          dataid={dataId}
          id={fieldId}
          name={fieldLabel}
          placeholder={fieldValue || defaultPlaceholder}
          p="0"
          border="none"
          borderRadius="0"
          accept="image/png, image/jpeg, image/webp, application/zip, .zip"
          onChange={(event) => handleOnChange(event.target.files[0])}
        />
        <Box pos="absolute" top="2px" left="28">
          {fileSelected !== null ? fileSelected : noFileSelectedMessage}
        </Box>
      </Box>
      {submitAttempted && isError && (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default FieldComponent;
